import * as React from 'react';
import NumberFormat from 'react-number-format';
import { ErrorMessage } from '../ErrorMessage';
import { IHasTestData } from '../../test-utilities/IHasTestData';
import { mergeTests } from '../../test-utilities/mergeTests';

export interface ICurrencyProps extends IHasTestData {
  emptyContent?: string | null;
  className?: string;
  showPrefix?: boolean;
  value?: string | number | null;
  valueIsCents?: boolean;
}

export const convertCurrencyToCents = (value: number) => {
  const paddedValue = value.toString().padStart(2, '0'); // FYI: padding so that even single digit amounts are output correctly
  return `${paddedValue.slice(0, -2)}.${paddedValue.substr(-2)}`;
};

export const convertCurrencyToDollars = (value: any) => {
  if (value) {
    return value * 100;
  } else {
    return null;
  }
};

/**
 * The HTML input with formatted value as amount of currency.
 */
export const Currency: React.FC<ICurrencyProps> = ({
  className,
  'data-test-id': dataTestId,
  'data-test-class': dataTestClass,
  emptyContent = null,
  showPrefix = true,
  value,
  valueIsCents,
}) => (
  <React.Fragment>
    {value !== undefined && value !== null ? (
      valueIsCents && typeof value === 'number' && value % 1 !== 0 ? (
        <ErrorMessage
          data-test-class={mergeTests(dataTestClass || 'currency-input', 'error')}
          message={`invalid value (${value}) can not be decimal when valueIsCents is enabled`}
        />
      ) : (
        <NumberFormat
          className={className}
          data-test-id={mergeTests(dataTestId, 'input')}
          data-test-class={dataTestClass || 'currency-input'}
          decimalScale={2}
          displayType={'text'}
          fixedDecimalScale={true}
          isNumericString={(valueIsCents && typeof value === 'number') || typeof value === 'string'}
          prefix={showPrefix ? '$' : ''}
          thousandSeparator={true}
          value={valueIsCents && typeof value === 'number' ? convertCurrencyToCents(value) : value}
        />
      )
    ) : emptyContent ? (
      <span className={className} data-test-class={mergeTests(dataTestClass || 'currency-input', 'empty-content')}>
        {emptyContent}
      </span>
    ) : null}
  </React.Fragment>
);
